const linkedInUrl = "https://www.linkedin.com/company/nawerobotics/";
const instagramUrl = "https://www.instagram.com/nawerobotics/";
const githubUrl = "https://www.github.com/nawerobotics";
const mailUrl = "mailto:info@nawerobotics.com";
const enc5047AmazonLink = "https://www.amazon.in/gp/product/B0992F16QQ";
const actuatorBrochureLink =
  "https://drive.google.com/file/d/1V_qm9oxarh4os8MTd75eim6e8nkj8OwY/view?usp=sharing";
const encoder5047Datasheet =
  "https://drive.google.com/file/d/1MxpkMdQ8JnZeZFZorGfRyg4PO6HZz0ba/view?usp=sharing";
const rfqFormLink = "https://forms.gle/gKzBmX39Uf7UKpWx6";

const enc730AmazonLink = "https://www.amazon.in/gp/product/B0BC9TYGGC";
const encoder730Datasheet = "https://drive.google.com/file/d/1OIeWO5_l13-KsSGQJ1Q-6F3WVVQt2Zae/view?usp=share_link";

module.exports = {
  linkedInUrl,
  instagramUrl,
  githubUrl,
  mailUrl,
  enc5047AmazonLink,
  actuatorBrochureLink,
  encoder5047Datasheet,
  enc730AmazonLink,
  encoder730Datasheet,
  rfqFormLink,
};
